import React from 'react';

export const WishlistIcon = () => {
    return null;
};
